module.exports = {
    account: {
        _id: null,
        name: null,
    },
    commission: null,
    readinessDate: undefined,
    cancellingDate: undefined,
    deliveryPlaces: [
        {
            port: {
                _id: null,
                name: null,
            },
            details: null,
            main: true,
        },
    ],
    redeliveryPlaces: [
        {
            port: {
                _id: null,
                name: null,
            },
            details: null,
            main: true,
        },
    ],
    tcDuration: null,
    vesselRequirements: {
        typeByPurpose: null,
        typeBySpecialty: null,
        typeByConstruction: null,
        ageMax: null,
        forHeavyCargoes: null,
        imoFitted: null,
        flags: [],
        dwtMin: null,
        dwtMax: null,
        typeSizes: [],
        geared: undefined,
        grabbed: null,
        capacityMin: null,
        capacityMax: null,
        scrubberFitted: null,
        strengthenHeavy: null,
        gearV2: {
            summary: [
                {
                    type: null,
                    quantity: null,
                    capacity: null,
                    outreach: null,
                    maxSWL: null,
                    combinable: false,
                },
            ],
        },
        grabV2: {
            summary: [
                {
                    type: null,
                    quantity: null,
                    volume: null,
                },
            ],
        },
        teuMin: null,
        teuMax: null,
        linerMeterMin: null,
        linerMeterMax: null,
        loaMax: null,
        beamMax: null,
        draftMax: null,
        piClubMember: null,
        registerClasses: [
            // {
            //     "registerClass": null,
            //     "iacsRegister": null,
            //     "excluded": null,
            // }
        ],
    },
    terms: {
        user: [],
        default: [],
    },
    eh: null,
    context: {
        parser: null,
        kind: null,
        userId: {
            _id: null,
            name: null,
            surname: null,
            email: null,
            company: null,
        },
        companyId: {
            _id: null,
            name: null,
        },
    },
    mailId: null,
    cargo: {
        included: [],
        excluded: [],
    },
};



// WEBPACK FOOTER //
// ./app/mocks/tc/order.js